var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyEscalationPolicySteps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 105,
    viewBox: "0 0 132 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.7568 9.03034C94.6973 9.03034 96.2703 7.45132 96.2703 5.5035C96.2703 3.55568 94.6973 1.97666 92.7568 1.97666C90.8163 1.97666 89.2433 3.55568 89.2433 5.5035C89.2433 7.45132 90.8163 9.03034 92.7568 9.03034Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3784 36.4638C18.8114 36.4638 19.973 35.2978 19.973 33.8594C19.973 32.421 18.8114 31.255 17.3784 31.255C15.9455 31.255 14.7838 32.421 14.7838 33.8594C14.7838 35.2978 15.9455 36.4638 17.3784 36.4638Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.919 21.4177L115.162 26.6809",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.919 26.6809L115.162 21.4177",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8919 91.1517L30.027 100.213C30.027 100.43 30.1892 100.539 30.4054 100.484L38.6757 96.6861C38.8378 96.5776 38.8919 96.3606 38.7297 96.252L31.3243 90.9347C31.1622 90.8261 30.946 90.9347 30.8919 91.1517Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.757 48.0508H110.676C110.459 48.0508 110.351 48.2678 110.459 48.4306L115 56.3524C115.108 56.5152 115.378 56.5152 115.432 56.3524L119.973 48.4306C120.081 48.2678 119.973 48.0508 119.757 48.0508Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipEmptyEscalationPolicySteps)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 54.5,
    r: 31.5,
    fill: "#DEDBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9391 70.7526C89.4176 75.3327 84.6802 79.0758 78.9545 81.4353C61.5932 88.5899 41.7192 80.3158 34.5647 62.9545C27.4101 45.5932 35.6843 25.7192 53.0455 18.5647C70.4068 11.4101 90.2808 19.6842 97.4354 37.0455C98.7614 40.2632 99.5574 43.5672 99.8638 46.8606",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9967 84.0057C60.2193 84.0105 54.3632 82.5413 49 79.4449C32.738 70.056 27.1663 49.2619 36.5551 33C45.944 16.7381 66.738 11.1663 83 20.5551C99.2619 29.944 104.834 50.7381 95.4448 67C93.7047 70.014 91.5728 72.6607 89.1507 74.9131",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 50,
    r: 25,
    stroke: "#5A4BF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 61.9365,
    y: 31,
    width: 15,
    height: 33,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 61.9365,
    y: 31,
    width: 15,
    height: 33
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5 33C65.1193 33 64 34.1193 64 35.5V50.9884C63.8383 51.6939 63.9827 52.4635 64.4608 53.0801L70.3042 60.6176C71.1501 61.7088 72.7205 61.9076 73.8117 61.0617C74.9029 60.2157 75.1018 58.6454 74.2558 57.5542L69 50.7747V35.5C69 34.1193 67.8807 33 66.5 33Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5 33C65.1193 33 64 34.1193 64 35.5V50.9884C63.8383 51.6939 63.9827 52.4635 64.4608 53.0801L70.3042 60.6176C71.1501 61.7088 72.7205 61.9076 73.8117 61.0617C74.9029 60.2157 75.1018 58.6454 74.2558 57.5542L69 50.7747V35.5C69 34.1193 67.8807 33 66.5 33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 50.9884L65.9495 51.4353L66 51.2147V50.9884H64ZM64.4608 53.0801L62.8801 54.3055L62.8801 54.3055L64.4608 53.0801ZM70.3042 60.6176L71.8848 59.3922L71.8848 59.3922L70.3042 60.6176ZM73.8117 61.0617L75.0371 62.6423H75.0371L73.8117 61.0617ZM74.2558 57.5542L75.8364 56.3288V56.3288L74.2558 57.5542ZM69 50.7747H67V51.4591L67.4194 52.0001L69 50.7747ZM66 35.5C66 35.2239 66.2239 35 66.5 35V31C64.0147 31 62 33.0147 62 35.5H66ZM66 50.9884V35.5H62V50.9884H66ZM66.0414 51.8547C65.9463 51.732 65.916 51.5813 65.9495 51.4353L62.0506 50.5416C61.7606 51.8064 62.0192 53.195 62.8801 54.3055L66.0414 51.8547ZM71.8848 59.3922L66.0414 51.8547L62.8801 54.3055L68.7236 61.843L71.8848 59.3922ZM72.5863 59.4811C72.3681 59.6502 72.054 59.6105 71.8848 59.3922L68.7236 61.843C70.2463 63.8072 73.0729 64.1651 75.0371 62.6423L72.5863 59.4811ZM72.6752 58.7795C72.8443 58.9978 72.8046 59.3119 72.5863 59.4811L75.0371 62.6423C77.0013 61.1196 77.3592 58.2929 75.8364 56.3288L72.6752 58.7795ZM67.4194 52.0001L72.6752 58.7795L75.8364 56.3288L70.5807 49.5493L67.4194 52.0001ZM67 35.5V50.7747H71V35.5H67ZM66.5 35C66.7762 35 67 35.2239 67 35.5H71C71 33.0147 68.9853 31 66.5 31V35Z",
    fill: "#5A4BF8",
    mask: "url(#path-11-outside-1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 50.5,
    r: 4.5,
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipEmptyEscalationPolicySteps"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 93,
    fill: "white",
    transform: "translate(0 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEscalationPolicySteps);
export default __webpack_public_path__ + "static/media/EmptyEscalationPolicySteps.6e018abacdbc16be0fc30591307048f4.svg";
export { ForwardRef as ReactComponent };